import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page8() {
  useEffect(() => {
    document.title = "Маяк — Страница 7"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page6" />
        <ForwardLink href="/page8" />
      </div>

      <p style={{ textAlign: "right" }}>7.</p>
      <p>
        МОЛОДОЙ останавливает себя, чтобы перефразировать, более уважительно. Это не<br/>
        легко для него -- демонстрировать хорошие манеры. Он не торопится, чтобы<br/>
        не возиться с многосложными словами.
      </p>
      <p style={{ textAlign: "center" }}>
        Я бы -- я понял, что это<br/>
        нарушение правил, сэр.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты понял?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Дасэр.
      </p>
      <p>СТАРИК не двигается с места. Его чашка все еще поднята.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Из инструкции.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Не думал, что ты умеешь читать.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Пытаюсь не нарваться на неприятности.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Тогда делай, как я говорю. Это тоже есть в твоей книге.
      </p>
      <p>Длинная пауза.</p>
      <p>МОЛОДОЙ улыбается. Выражение его лица словно говорит: “Этот старик тот еще тип.”</p>
      <p>МОЛОДОЙ очень осторожно берет свою чашку.</p>
      <p>Встает.</p>
      <p>Пауза.</p>
      <p>Он подходит к деревенской раковине и выливает выпивку.</p>
      <p>Наливает немного воды в чашку.</p>
      <p>Садится обратно.</p>
      <p>Поднимает свою чашку для тоста. Он горд. Он победил.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        За четыре недели.
      </p>
      <p>СТАРИК улыбается -- слишком широко. Они чокаются.</p>
      <p>Выпивают...</p>
      <p style={{ textAlign: "right" }}>7.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page6" />
        <ForwardLink href="/page8" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710102010/the-lighthouse-script/toyezakixxacnfpmaoxo.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page8;
